"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeAjaxOptions = exports.AjaxFuncs = void 0;
exports.AjaxFuncs = {
    includeResponse: "includeResponse",
    options: "options",
};
function mergeAjaxOptions(o1, o2) {
    if (o1 == null) {
        return o2;
    }
    if (o2 == null) {
        return o1;
    }
    return {
        data: o1.data ? (o2.data ? Object.assign({}, o1.data, o2.data) : o1.data) : o2.data,
        headers: o1.headers ? Object.assign({}, o1.headers, o2.headers) : o2.headers,
        method: o2.method || o1.method,
        params: (o1.params || []).concat(o2.params || []),
        timeout: o2.timeout || o1.timeout,
        url: o2.url || o1.url,
    };
}
exports.mergeAjaxOptions = mergeAjaxOptions;
//# sourceMappingURL=ajax.js.map